<style>
  .vid_side_box_inner {
  padding: 0 0 5px 0 !important;
  margin: 5px 0 0 !important;
  border-bottom: 1px solid #eee;
}
</style>
<div class="new-screen3">
  <div class="container flex flex-col">
    <h5 class="all-head">TV</h5>
    <div class="flex flex-col gap-[16px]">
      <div class="flex desk-brdr-btm display-mob max-md:!flex-col md:flex-row md:gap-[20px] max-md:!gap-[16px]">
        <div class="flex-[1_1_100%]">
          <div class="flex flex-col">
            <div class="flex flex-col">
              <ul>
                <div class="flex max-md:!flex-col md:flex-row md:gap-[20px] max-md:!gap-[8px]">
                  <!-- <ng-template ngFor let-item [ngForOf]="createRange(4)" let-currentIndex="index"> -->
                  @if (conv?.length > 0) {
                    @for (item of conv.slice(0, 4); track item) {
                      <div class="mob-brdr-btm max-md:!flex-[1_1_100%] md:flex-[1_1_25%]">
                        <a [href]="buildHrefLink(item)">
                          <li class="flex flex-col">
                            <div class="mrg-after-imgvid">
                              <img [appImgFallback]="item?.['image_url']" imgContext="thumb" alt="{{item['doctor'] && item['doctor']?.['name'] || ''}}" style="width:100%" />
                            </div>
                            <div>
                              <p class="internal-updates-head">{{item['headline'] || ''}}</p>
                            </div>
                          </li>
                        </a>
                      </div>
                    }
                  }
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="flex max-md:!flex-col md:flex-row md:gap-[20px] max-sm:!gap-[0px] max-md:!gap-[8px]">
        <div class="flex max-md:!flex-[1_1_100%] md:flex-[1_1_50%] max-sm:!flex-col sm:flex-row max-sm:!gap-[16px] sm:gap-[20px]">
          <!-- <ng-template ngFor let-item [ngForOf]="createRange(2)" let-currentIndex="index+4"> -->
          @if (conv?.length > 4) {
            @for (item of conv.slice(4, 6); track item) {
              <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%]">
                <div class="mob-brdr-btm flex flex-col">
                  <a [href]="buildHrefLink(item)">
                    <div class="mrg-after-imgvid">
                      <img [appImgFallback]="item?.['image_url']" imgContext="thumb" alt="{{item['doctor'] && item['doctor']?.['name'] || ''}}" style="width:100%" />
                    </div>
                  </a>
                  <a [href]="buildHrefLink(item)">
                    <ul class="flex flex-col">
                      <li class="flex flex-col">
                        <p class="internal-updates-head">{{item['headline'] || ''}}</p>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            }
          }
        </div>
        <div class="flex max-sm:!flex-col sm:flex-row max-md:!flex-[1_1_100%] md:flex-[1_1_50%] max-sm:!gap-[0px] sm:gap-[20px]">
          <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%]">
            <div class="mrg-pad3 flex flex-col">
              <ul class="flex flex-col">
                @if (conv?.length > 6) {
                  @for (item of conv.slice(6, 10); track item) {
                    <div>
                      <a [href]="buildHrefLink(item)">
                        <li class="brdr-btm flex flex-col">
                          <p class="internal-updates-head">{{item['headline'] || ''}}</p>
                        </li>
                      </a>
                    </div>
                  }
                }
              </ul>
            </div>
          </div>
          <div class="max-md:!flex-[1_1_100%] sm:flex-[1_1_50%]">
            <div class="flex flex-col">
              <ul class="flex flex-col">
                @if (conv?.length > 9) {
                  @for (item of conv.slice(9, 12); track item) {
                    <div>
                      <a [href]="buildHrefLink(item)">
                        <li class="brdr-btm flex flex-col">
                          <p class="internal-updates-head">{{item['headline'] || ''}}</p>
                        </li>
                      </a>
                    </div>
                  }
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="/tv">
      <button mat-flat-button class="view-all-btn">View all</button>
    </a>
  </div>
</div>
